/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TechnicianJobConcernDocumentModelV2 } from '../models/TechnicianJobConcernDocumentModelV2';
import type { TechnicianJobConcernPhotoModelV2 } from '../models/TechnicianJobConcernPhotoModelV2';
import type { TechnicianJobConcernSubmitModel } from '../models/TechnicianJobConcernSubmitModel';
import type { TechnicianJobConcernVideoModelV2 } from '../models/TechnicianJobConcernVideoModelV2';
import type { TechnicianJobCreateRepairModelV2 } from '../models/TechnicianJobCreateRepairModelV2';
import type { TechnicianJobCreateTSBCheckModel } from '../models/TechnicianJobCreateTSBCheckModel';
import type { TechnicianJobDetailedModelV2 } from '../models/TechnicianJobDetailedModelV2';
import type { TechnicianJobDetailModel } from '../models/TechnicianJobDetailModel';
import type { TechnicianJobLogModelPagedListData } from '../models/TechnicianJobLogModelPagedListData';
import type { TechnicianJobPartsNotificationModel } from '../models/TechnicianJobPartsNotificationModel';
import type { TechnicianJobRepairLabourSubmitModel } from '../models/TechnicianJobRepairLabourSubmitModel';
import type { TechnicianJobRepairLabourSubmitShortModel } from '../models/TechnicianJobRepairLabourSubmitShortModel';
import type { TechnicianJobRepairLineCreationResponseModel } from '../models/TechnicianJobRepairLineCreationResponseModel';
import type { TechnicianJobRepairPartSubmitModel } from '../models/TechnicianJobRepairPartSubmitModel';
import type { TechnicianJobRepairPartSubmitShortModel } from '../models/TechnicianJobRepairPartSubmitShortModel';
import type { TechnicianJobSendEmailModel } from '../models/TechnicianJobSendEmailModel';
import type { TechnicianJobSentEmailModel } from '../models/TechnicianJobSentEmailModel';
import type { TechnicianJobSubmitDescriptionModelV2 } from '../models/TechnicianJobSubmitDescriptionModelV2';
import type { TechnicianJobSubmitModel } from '../models/TechnicianJobSubmitModel';
import type { TechnicianJobSubmitModelV2 } from '../models/TechnicianJobSubmitModelV2';
import type { TechnicianJobUploadDocumentResponseModel } from '../models/TechnicianJobUploadDocumentResponseModel';
import type { TechnicianJobUploadPhotoResponseModel } from '../models/TechnicianJobUploadPhotoResponseModel';
import type { TechnicianRepairConcernPartsWithPartRequestsModel } from '../models/TechnicianRepairConcernPartsWithPartRequestsModel';
import type { TechnicianStatusEnum } from '../models/TechnicianStatusEnum';
import type { TechnicianUserModel } from '../models/TechnicianUserModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TechnicianJobService {

  /**
   * @param page 
   * @param pageSize 
   * @param status
 *
 * 1 = Active
 *
 * 2 = Invoiced
   * @param dateFrom 
   * @param dateTo 
   * @param regNo 
   * @param technicianId 
   * @param branchId 
   * @returns TechnicianJobLogModelPagedListData Success
   * @throws ApiError
   */
  public static getTechnicianJob(
page?: number,
pageSize?: number,
status?: TechnicianStatusEnum,
dateFrom?: string,
dateTo?: string,
regNo?: string,
technicianId?: number,
branchId?: number,
): CancelablePromise<TechnicianJobLogModelPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technician-job',
      query: {
        'Page': page,
        'PageSize': pageSize,
        'Status': status,
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'RegNo': regNo,
        'TechnicianId': technicianId,
        'BranchId': branchId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postTechnicianJob(
requestBody?: TechnicianJobSubmitModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postTechnicianJobSetAuthorize(
id: number,
requestBody?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/set-authorize/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteTechnicianJob(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/technician-job/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putTechnicianJob(
id: number,
requestBody?: TechnicianJobSubmitModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/technician-job/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteTechnicianJobRepair(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/technician-job/repair/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param wip 
   * @param userId 
   * @param branchId 
   * @returns any Success
   * @throws ApiError
   */
  public static getTechnicianJobLookUp(
wip?: number,
userId?: number,
branchId: number = 1,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technician-job/look-up',
      query: {
        'wip': wip,
        'userId': userId,
        'branchId': branchId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns TechnicianJobRepairLineCreationResponseModel Created
   * @throws ApiError
   */
  public static postTechnicianJobRepairLabour(
requestBody?: TechnicianJobRepairLabourSubmitModel,
): CancelablePromise<TechnicianJobRepairLineCreationResponseModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/repair-labour',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postTechnicianJobRepairLabour1(
id: number,
requestBody?: TechnicianJobRepairLabourSubmitShortModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{id}/repair-labour',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteTechnicianJobRepairLabour(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/technician-job/{id}/repair-labour',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns TechnicianJobRepairLineCreationResponseModel Created
   * @throws ApiError
   */
  public static postTechnicianJobRepairPart(
requestBody?: TechnicianJobRepairPartSubmitModel,
): CancelablePromise<TechnicianJobRepairLineCreationResponseModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/repair-part',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Created
   * @throws ApiError
   */
  public static postTechnicianJobPartsNotification(
requestBody?: TechnicianJobPartsNotificationModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/parts-notification',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postTechnicianJobRepairPart1(
id: number,
requestBody?: TechnicianJobRepairPartSubmitShortModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{id}/repair-part',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteTechnicianJobRepairPart(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/technician-job/{id}/repair-part',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns string Success
   * @throws ApiError
   */
  public static postTechnicianJobDocuments(
id: number,
formData?: {
userId?: number;
files?: Array<Blob>;
},
): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{id}/documents',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param guid 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteTechnicianJobDocuments(
guid?: string,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/technician-job/documents',
      query: {
        'guid': guid,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns string Success
   * @throws ApiError
   */
  public static postTechnicianJobPhotos(
id: number,
formData?: {
userId?: number;
files?: Array<Blob>;
},
): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{id}/photos',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param photoGuid 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteTechnicianJobPhotos(
photoGuid?: string,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/technician-job/photos',
      query: {
        'photoGuid': photoGuid,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param soHeaderId 
   * @param email 
   * @param subject 
   * @param body 
   * @returns TechnicianJobSendEmailModel Success
   * @throws ApiError
   */
  public static getTechnicianJobEmailBody(
id: number,
soHeaderId?: number,
email?: string,
subject?: string,
body?: string,
): CancelablePromise<TechnicianJobSendEmailModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technician-job/{id}/email-body',
      path: {
        'id': id,
      },
      query: {
        'SoHeaderId': soHeaderId,
        'Email': email,
        'Subject': subject,
        'Body': body,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postTechnicianJobEmail(
id: number,
requestBody?: TechnicianJobSentEmailModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{id}/email',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @param userId 
   * @param id 
   * @returns TechnicianJobDetailModel Success
   * @throws ApiError
   */
  public static getTechnicianJobJobDetails(
soHeaderId?: number,
userId?: number,
id?: number,
): CancelablePromise<TechnicianJobDetailModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technician-job/job-details',
      query: {
        'soHeaderId': soHeaderId,
        'userId': userId,
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @returns TechnicianUserModel Success
   * @throws ApiError
   */
  public static getTechnicianJobTechUsers(): CancelablePromise<Array<TechnicianUserModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technician-job/tech-users',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param userId 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postTechnicianJobCreateQuoteLaboursFromTechnicianJob(
id: number,
userId?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{id}/create-quote-labours-from-technician-job',
      path: {
        'id': id,
      },
      query: {
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns TechnicianRepairConcernPartsWithPartRequestsModel Success
   * @throws ApiError
   */
  public static getTechnicianJobTechnicianRepairsPartsWithPartRequests(
id: number,
): CancelablePromise<Array<TechnicianRepairConcernPartsWithPartRequestsModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technician-job/{id}/technician-repairs-parts-with-part-requests',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Создание записи technician job с минимальным количеством параметров
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postTechnicianJobV2(
requestBody?: TechnicianJobSubmitModelV2,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/v2',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Создание записи Concern для technician job
   * @param techJobId Id записи technician job
   * @param requestBody Модель сабмита Technician Job Concern
   * @returns number Created
   * @throws ApiError
   */
  public static postTechnicianJobConcern(
techJobId: number,
requestBody?: TechnicianJobConcernSubmitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{techJobId}/concern',
      path: {
        'techJobId': techJobId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Создание записи Description для technician job concern
   * @param concernId Id записи technician job concern
   * @param requestBody Модель сабмита Technician Job Concern Description
   * @returns number Created
   * @throws ApiError
   */
  public static postTechnicianJobDescription(
concernId: number,
requestBody?: TechnicianJobSubmitDescriptionModelV2,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{concernId}/description',
      path: {
        'concernId': concernId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Обновление записи Description для technician job concern
   * @param descriptionId Id записи Technician Job Description
   * @param requestBody Модель сабмита Technician Job Concern Description
   * @returns boolean Success
   * @throws ApiError
   */
  public static patchTechnicianJobDescription(
descriptionId: number,
requestBody?: TechnicianJobSubmitDescriptionModelV2,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/technician-job/{descriptionId}/description',
      path: {
        'descriptionId': descriptionId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Удаление записи Technician Job Concern Description
   * @param descriptionId Id записи Technician Job Concern Description
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteTechnicianJobDescription(
descriptionId: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/technician-job/{descriptionId}/description',
      path: {
        'descriptionId': descriptionId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Создание записи Technician Job Concern TSB Check
   * @param concernId Id записи Technician Job Concern
   * @param requestBody Модель сабмита Technician Job Concern TSB Check
   * @returns number Created
   * @throws ApiError
   */
  public static postTechnicianJobTsbCheck(
concernId: number,
requestBody?: TechnicianJobCreateTSBCheckModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{concernId}/tsb-check',
      path: {
        'concernId': concernId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Обновление записи Technician Job Concern TSB Check
   * @param tsbCheckId Id записи Technician Job Concern TSB Check
   * @param requestBody Модель сабмита Technician Job Concern TSB Check
   * @returns boolean Success
   * @throws ApiError
   */
  public static patchTechnicianJobTsbCheck(
tsbCheckId: number,
requestBody?: TechnicianJobCreateTSBCheckModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/technician-job/{tsbCheckId}/tsb-check',
      path: {
        'tsbCheckId': tsbCheckId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Создание записи Technician Job Concern Repair
   * @param concernId Id записи Technician Job Concern
   * @param requestBody Модель сабмита Technician Job Repair
   * @returns number Created
   * @throws ApiError
   */
  public static postTechnicianJobRepair(
concernId: number,
requestBody?: TechnicianJobCreateRepairModelV2,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{concernId}/repair',
      path: {
        'concernId': concernId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Обновление записи Technician Job Concern Repair
   * @param repairId Id записи Technician Job Concern
   * @param requestBody Модель сабмита Technician Job Repair
   * @returns boolean Created
   * @throws ApiError
   */
  public static patchTechnicianJobRepair(
repairId: number,
requestBody?: TechnicianJobCreateRepairModelV2,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/technician-job/{repairId}/repair',
      path: {
        'repairId': repairId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Загрузка документов для записи Technician Job Concern
   * @param concernId Id записи Technician Job Concern
   * @param formData 
   * @returns TechnicianJobUploadDocumentResponseModel Success
   * @throws ApiError
   */
  public static postTechnicianJobDocumentsV2(
concernId: number,
formData?: {
userId?: number;
files?: Array<Blob>;
},
): CancelablePromise<Array<TechnicianJobUploadDocumentResponseModel>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{concernId}/documents-v2',
      path: {
        'concernId': concernId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Получение списка документов для записи Technician Job с разбивкой по concern
   * @param soHeaderId Id записи SoHeader, к которой прикреплена запись technician job
   * @returns TechnicianJobConcernDocumentModelV2 Success
   * @throws ApiError
   */
  public static getTechnicianJobDocumentsV2(
soHeaderId: number,
): CancelablePromise<Array<TechnicianJobConcernDocumentModelV2>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technician-job/{soHeaderId}/documents-v2',
      path: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Загрузка фото для записи Technician Job Concern
   * @param concernId Id записи Technician Job Concern
   * @param formData 
   * @returns TechnicianJobUploadPhotoResponseModel Success
   * @throws ApiError
   */
  public static postTechnicianJobPhotosV2(
concernId: number,
formData?: {
userId?: number;
files?: Array<Blob>;
},
): CancelablePromise<Array<TechnicianJobUploadPhotoResponseModel>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{concernId}/photos-v2',
      path: {
        'concernId': concernId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Получение списка фото для записи Technician Job с разбивкой по concern
   * @param soHeaderId Id записи SoHeader, к которой прикреплена запись technician job
   * @returns TechnicianJobConcernPhotoModelV2 Success
   * @throws ApiError
   */
  public static getTechnicianJobPhotosV2(
soHeaderId: number,
): CancelablePromise<Array<TechnicianJobConcernPhotoModelV2>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technician-job/{soHeaderId}/photos-v2',
      path: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Удаление technician job photo по id
   * @param photoId Id записи technician job photo
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteTechnicianJobPhotosV2(
photoId: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/technician-job/{photoId}/photos-v2',
      path: {
        'photoId': photoId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Удаление technician job document по id
   * @param documentId Id записи technician job document
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteTechnicianJobDocumentsV2(
documentId: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/technician-job/{documentId}/documents-v2',
      path: {
        'documentId': documentId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Получение записи Technician Job по Id
 * Учитывает старую реализацию без привязки к concern
   * @param id Id записи Technician Job
   * @returns TechnicianJobDetailedModelV2 Success
   * @throws ApiError
   */
  public static getTechnicianJobV2(
id: number,
): CancelablePromise<TechnicianJobDetailedModelV2> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technician-job/{id}/v2',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Получение прикреплённых к concern записей video log
   * @param id SoHeader Id
   * @returns TechnicianJobConcernVideoModelV2 Success
   * @throws ApiError
   */
  public static getTechnicianJobVideos(
id: number,
): CancelablePromise<Array<TechnicianJobConcernVideoModelV2>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technician-job/{id}/videos',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Установка статуса Completed для записи Technician Job Concern
   * @param concernId Id записи Technician Job Concern
   * @param userId Юзер, установивший статус Completed
   * @returns boolean Success
   * @throws ApiError
   */
  public static postTechnicianJobComplete(
concernId: number,
userId?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{concernId}/complete',
      path: {
        'concernId': concernId,
      },
      query: {
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Убирает статус Completed в записи Technician Job Concern
   * @param concernId Id записи Technician Job Concern
   * @returns boolean Success
   * @throws ApiError
   */
  public static postTechnicianJobUncomplete(
concernId: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{concernId}/uncomplete',
      path: {
        'concernId': concernId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
